const LOGO_SRC = "/brand/logo_round.png";

export default function Logo({ size = "md", className = "" }) {
  const h = size === "lg" ? "h-20" : size === "sm" ? "h-9" : "h-12";
  return (
    <img
      data-testid="brand-logo"
      src={LOGO_SRC}
      alt="Mandalay+"
      className={`${h} w-auto object-contain select-none ${className}`}
    />
  );
}
